import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20.8388 6.69461L8.81799 18.7154L3.16113 13.0586L4.57113 11.6486L8.81799 15.8854L19.4288 5.28461L20.8388 6.69461Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CheckBig"
);
